<h1 mat-dialog-title>{{ 'labels.heading.Disable' | translate }}</h1>
<div mat-dialog-content>
  <p>{{ 'labels.text.Are you sure you want to disable' | translate }} {{ data.disableContext }} ?</p>
</div>
<mat-dialog-actions align="end">
  <button mat-raised-button mat-dialog-close>{{ 'labels.buttons.Cancel' | translate }}</button>
  <button mat-raised-button color="warn" [mat-dialog-close]="{ disable: true }">
    {{ 'labels.buttons.Confirm' | translate }}
  </button>
</mat-dialog-actions>
